import React from 'react';
import PropTypes from 'prop-types';

import {
  SummaryContainer,
  NameHead,
  NameWrapper,
  AccountDetail,
  AccountDetails
} from './styles';
import { formatAmount, nameFormatter } from '../../../../../utils/commonUtil';

const AccountSummaryWeb = ({ userData }) => {
  return (
    <SummaryContainer data-test='faUserDetailsWebBlock'>
      <NameWrapper>
        <NameHead>
          {`Welcome, ${nameFormatter(
            userData.faFirstName,
            userData.faMiddleName,
            userData.faLastName,
            userData.faSuffix
          )}`}
        </NameHead>
        <AccountDetail data-test='faUserWebDetailCompany'>
          {userData.company ? userData.company : null}
        </AccountDetail>
      </NameWrapper>
      <AccountDetails primary={userData.noOfManAccts > 10 ? true : false}>
        <div>
          <span>{userData.noOfManAccts}</span>
          <span>Managed Accounts</span>
        </div>
        <div>
          <span>{`${formatAmount(userData.totalAssets)}`}</span>
          <span>Assets under management</span>
        </div>
      </AccountDetails>
    </SummaryContainer>
  );
};

export default AccountSummaryWeb;

AccountSummaryWeb.propTypes = {
  userData: PropTypes.shape({
    faFirstName: PropTypes.string.isRequired,
    faMiddleName: PropTypes.string.isRequired,
    faLastName: PropTypes.string.isRequired,
    faSuffix: PropTypes.string.isRequired,
    company: PropTypes.string,
    noOfManAccts: PropTypes.number.isRequired,
    totalAssets: PropTypes.number.isRequired,
  }),
};